/**
 * Abstract Hypercube.js script.
 * @example
 * class ScriptExample extends Script {}
 */
class Script {

    /**
     * Stores the Hypercube.js Game Engine running the script.
     * @type {import('../../index.js').Engine}
     * @protected
     */
    $engine;

    /**
     * Stores the running status of the script.
     * @type {boolean}
     * @protected
     */
    $running;

    /**
     * Gets the Hypercube.js Game Engine running the script.
     * @type {import('../../index.js').Engine}
     * @public
     * @readonly
     */
    get engine() {

        return this.$engine;
    }

    /**
     * Gets the running status of the script.
     * @type {boolean}
     * @public
     * @readonly
     */
    get running() {

        return this.$running;
    }

    /**
     * Gets the scene running.
     * @type {import('../../index.js').Scene}
     * @public
     * @readonly
     */
    get scene() {

        return this.$engine.scene;
    }

    /**
     * Creates a new Hypercube.js script.
     */
    constructor() {

        this.$running = false;
    }

    /**
     * Called when a collision system detects a collision.
     * @param {number} $timebeforecollision The elapsed time before the collision occurred.
     * @param {import('../../index.js').Node} $entity The first node on which the script is attached.
     * @param {import('../../index.js').Node} $other The second node on which the first has collide.
     * @public
     */
    oncollide($timebeforecollision, $entity, $other) {}

    /**
     * Called when the node is destroyed.
     * @param {import('../../index.js').Node} $entity The node on which the script is attached.
     * @public
     */
    ondestroy($entity) {}

    /**
     * Called when an input system detects an input event.
     * @param {import('../../index.js').Node} $entity The node on which the script is attached.
     * @param {Event} $event The input event.
     * @public
     */
    oninput($entity, $event) {}

    /**
     * Called when the node is started.
     * @param {import('../../index.js').Node} $entity The node on which the script is attached.
     * @public
     */
    onstart($entity) {}

    /**
     * Called when the node is updated by one tick update.
     * @param {number} $timeframe The timeframe duration (in ms).
     * @param {import('../../index.js').Node} $entity The node on which the script is attached.
     * @public
     */
    ontick($timeframe, $entity) {}

    /**
     * Sets the Hypercube.js Game Engine running the script.
     * @param {import('../../index.js').Engine} $engine The Hypercube.js Game Engine to set.
     * @public
     */
    setengine($engine) {

        this.$engine = $engine;
        this.$running = true;
    }
}

export {

    Script
};

export default Script;
